import Pill from '../Components/Pill'
import {useParams} from 'react-router-dom'
import AppearOnScroll from './AppearOnScroll';


function Textimage(props) {
    let {projectName} = useParams();
    let project = require("../projects.json");
    let projectinfo = project.filter(project => project.project_name === projectName)[0];

    return (
        
        <div className=" flex flex-col md:flex-row w-full gap-12">
            <div className='flex flex-col items-start md:w-40 gap-8'>
                <AppearOnScroll>
                {props.pill ? 
                <div className='flex flex-initial'>
                    <Pill>{props.pill}</Pill>
                </div> : <></>}
                </AppearOnScroll>
                <div className='flex flex-col text-left gap-4 w-full'>
                    <AppearOnScroll delay={0.2}>
                    <h1 className='text-2xl font-medium font-display'>{props.heading}</h1>
                    </AppearOnScroll>
                    <AppearOnScroll delay={0.3}>
                    <p className='text-lg font-normal font-body leading-relaxed'>{props.info}</p>
                    </AppearOnScroll>
                </div>

            </div>
            
            {props.image ? 
            <div className="flex md:w-60  aspect-video">
                    <img 
                    src={`/img/${projectinfo.folder}/${props.image}`}
                    alt={`Afbeelding voor ${projectinfo.project_name}`} 
                    className="rounded-image w-full object-contain align-middle" 
                />
                </div>
             : <></>}
                
            

        </div>
    );
  }
  
  export default Textimage;